import LevelsMixin from './LevelsMixin';

export default {

    mixins: [ LevelsMixin ],

    methods: {
        childLevelClass(child) {
            return this.levelClass(child.level);
        },

        thumbnail(child) {
            if (!!child && typeof child.media !== 'undefined' && child.media.length > 0) {
                return child.media[0].thumb;
            }

            return '/images/no-photo.jpeg';
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/mixins/ChildMixin.js